import React from 'react';
import { Link } from 'react-router-dom';
import MelioLogo from '../MelioLogo';

interface PublicPageShellProps {
  children: React.ReactNode;
  backHref?: string;
  backLabel?: string;
  headerClassName?: string;
  mainClassName?: string;
  contentClassName?: string;
  headerStyle?: React.CSSProperties;
}

export default function PublicPageShell({
  children,
  backHref,
  backLabel,
  headerClassName = 'px-6 py-8 md:px-12',
  mainClassName = 'flex-1 px-6 md:px-12 pb-16',
  contentClassName = 'max-w-3xl mx-auto',
  headerStyle,
}: PublicPageShellProps) {
  return (
    <div
      className="min-h-screen flex flex-col"
      style={{
        backgroundColor: 'var(--melio-cream)',
        color: 'var(--melio-charcoal)',
        fontFamily: "var(--melio-sans)",
      }}
    >
      <header className={headerClassName} style={headerStyle}>
        <div className={`mx-auto flex items-center justify-between gap-4 ${contentClassName}`}>
          <Link to="/" className="inline-flex">
            <MelioLogo />
          </Link>
          {backHref && backLabel ? (
            <Link to={backHref} className="text-sm" style={{ color: 'var(--melio-text-muted)' }}>
              {backLabel}
            </Link>
          ) : <div />}
        </div>
      </header>
      <main className={mainClassName}>
        <div className={contentClassName}>{children}</div>
      </main>
    </div>
  );
}
